export default "__VITE_PUBLIC_ASSET__bb6366a9__"